import { useQuery } from '@tanstack/react-query';

import { DiscardReason } from '@restworld/utility-types';
import { useWorkerJobPositionsService } from '@restworld/data-services';

export function useDiscardReasonsForJobApplication(jobApplicationId: string | undefined) {
  const workerJobPositionsService = useWorkerJobPositionsService();

  return useQuery({
    queryKey: ['discard-reasons', jobApplicationId],
    queryFn: async () => {
      if (!jobApplicationId) return [];
      const { data } = await workerJobPositionsService.getDiscardReasonsForJobApplication(jobApplicationId);
      return data as DiscardReason[];
    },
    enabled: !!jobApplicationId,
    staleTime: 5 * 60 * 1000,
  });
}
